var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-default font-weight-normal trash-button",on:{"click":_vm.confirmDelete}},[_c('i',{staticClass:"fa fa-trash-o"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }